import { useState, useEffect, useRef } from "react";
import { Box, Button, Stack } from "@mui/material";
import { Close } from "@mui/icons-material";

export default function GuideTooltip() {
  const [tooltipVisible, setTooltipVisible] = useState(() => {
    // 로컬스토리지에서 툴팁 상태 확인
    try {
      const savedTooltipState = localStorage.getItem("tooltipClosed");
      return savedTooltipState !== "true";
    } catch (error) {
      console.error("로컬스토리지에서 툴팁 상태를 읽는데 실패했습니다:", error);
      return true; // 기본값으로 표시
    }
  });
  const [tooltipPosition, setTooltipPosition] = useState({
    left: 0,
    right: "auto",
  });
  const tooltipRef = useRef(null);

  const handleTooltipClose = () => {
    setTooltipVisible(false);

    // 로컬스토리지에 툴팁 닫힌 상태 저장
    try {
      localStorage.setItem("tooltipClosed", "true");
    } catch (error) {
      console.error(
        "로컬스토리지에 툴팁 상태를 저장하는데 실패했습니다:",
        error
      );
    }
  };

  // 툴팁 위치 계산 함수
  const calculateTooltipPosition = () => {
    if (tooltipRef.current) {
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const tooltipWidth = 400; // maxWidth 값

      // 툴팁이 화면 오른쪽을 벗어나는지 확인
      if (tooltipRect.left + tooltipWidth > windowWidth) {
        // 오른쪽 정렬로 변경
        setTooltipPosition({ left: "auto", right: 0 });
      } else {
        // 왼쪽 정렬 유지
        setTooltipPosition({ left: 0, right: "auto" });
      }
    }
  };

  // 툴팁이 보일 때 위치 계산
  useEffect(() => {
    if (tooltipVisible) {
      // 약간의 지연을 두고 계산 (DOM 업데이트 후)
      setTimeout(calculateTooltipPosition, 0);
    }
  }, [tooltipVisible]);

  if (!tooltipVisible) return null;

  return (
    <Box
      ref={tooltipRef}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        padding: "8px 12px",
        backgroundColor: "#E3F2FD",
        borderRadius: "8px",
        color: "#1976d2",
        fontSize: "14px",
        fontWeight: "500",
        maxWidth: "400px",
        position: "absolute",
        top: "100%",
        left: tooltipPosition.left,
        right: tooltipPosition.right,
        marginTop: "8px",
        zIndex: 1000,
        whiteSpace: "nowrap",
      }}
    >
      <Box
        sx={{
          fontSize: "16px",
          fontWeight: "bold",
        }}
      >
        *
      </Box>
      <Box>관리자 이용 가이드를 통해 예약을 직접 관리해보세요.</Box>
      <Button
        onClick={handleTooltipClose}
        size="small"
        sx={{
          minWidth: "auto",
          padding: "4px",
          color: "#1976d2",
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.1)",
          },
        }}
      >
        <Close fontSize="small" />
      </Button>
    </Box>
  );
}
